import React from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import { isEmail } from 'validator';
import TextFieldGroup from '../common/TextFieldGroup';
import { servAddr } from '../../servAddr';
import Form from '../ui/Form';

class ResetPassPage extends Form {

  state = {
    data: {login: ""},
    errors: {},
    success: "",
    posting: false
  }

  resetPass = () => {
    const { login } = this.state.data;
    if (!isEmail(login)) {
      this.setState({
        errors: {login:  'Неверный формат'}
      });
      return;
    }
    this.setState({posting: true, errors: {}});
    axios.post(servAddr + 'resetpass', {login}).then(response => {
      this.setState({
        posting: false,
        success: response.data
      });
    }, err => {
      this.setState({
        posting: false,
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  render() {
    const { data, errors, success, posting } = this.state;
    return (
      <div className="row">
        <div className="col-md-4 col-md-offset-4">
          <h1>Забыли пароль?</h1>
          <p>
            Введите E-mail, который вы используете для входа, и нажмите
            "Сбросить пароль".
          </p>
          <TextFieldGroup
            placeholder="E-mail"
            autoFocus
            onChange={this.updateInput}
            value={data.login}
            type="text"
            field="login"
            error={errors.login}
          />
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          {!success && (
            <div className="form-group">
              <button
                className="btn btn-primary btn-lg"
                onClick={this.resetPass}
                disabled={posting}
              >
                Сбросить пароль
              </button>
            </div>
          )}
          <Link to="/login">Назад</Link>
        </div>
      </div>
    );
  }
}

export default ResetPassPage;



// WEBPACK FOOTER //
// ./src/components/login/ResetPassPage.js